import { v4 as uuidv4 } from 'uuid';

export const TEMPLATES_URL = "/templates";

export const DATA_PROVIDER = "Data_Provider";

export const NONE = "None";

export const HIDDEN_COLUMNS = ["Company ID", "Employee ID"];

// TODO: move these to the database, so that they can be changed without redeploying the app and they can be centralized
export const DATA_VALIDATION_TYPES = {
   REQUIRED: "REQUIRED",
   ND_REQUIRED: "ND_REQUIRED",
   NA_REQUIRED: "NA_REQUIRED",
   MARKER: "MARKER",
   ND_NOT_REQUIRED: "ND_NOT_REQUIRED",
   NOT_REQUIRED_NOT_ND_NA: "NOT_REQUIRED_NOT_ND_NA",
   NOT_REQUIRED: "NOT_REQUIRED",
};

export const TEMPLATE_TYPE = {
   EXECUTIVE: "Executive",
   BROAD_BASED: "Broad-based",
   SURVEY: "Survey"
};

export const DATA_TYPES = {
   STRING: "STRING",
   NUMBER: "NUMBER",
   DATE: "DATE",
   COMPOSITE_COMPANY_ID: "COMPOSITE_COMPANY_ID",
   CURRENCY: "CURRENCY"
};

export const TICKER_COLUMN_DEFINITION = {
   tempId: uuidv4(),
   name: "Ticker",
   systemName: "ticker",
   dataType: DATA_TYPES.COMPOSITE_COMPANY_ID,
   validations: DATA_VALIDATION_TYPES.REQUIRED,
   position: "",
   sheetName: "",
   isSummaryAttribute: true,
   isFilterable: false,
   isTitleCode: false,
   secondaryReview: false
};

export const STANDARD_COLUMNS = [
   TICKER_COLUMN_DEFINITION,
   {
      tempId: uuidv4(),
      name: "Company ID",
      systemName: "company_id",
      dataType: DATA_TYPES.STRING,
      validations: DATA_VALIDATION_TYPES.REQUIRED,
      position: "",
      sheetName: "",
      isSummaryAttribute: true,
      isFilterable: false,
      isTitleCode: false,
      secondaryReview: false
   },
   {
      tempId: uuidv4(),
      name: "Company Name",
      systemName: "company_name",
      dataType: DATA_TYPES.STRING,
      validations: DATA_VALIDATION_TYPES.REQUIRED,
      position: "",
      sheetName: "",
      isSummaryAttribute: true,
      isFilterable: false,
      isTitleCode: false,
      secondaryReview: false
   }
];

const RESEARCH_ANALYSIS_STANDARD_COLUMNS = [
   ...STANDARD_COLUMNS,
   {
      tempId: uuidv4(),
      name: "FYE",
      systemName: "fye",
      dataType: DATA_TYPES.DATE,
      validations: DATA_VALIDATION_TYPES.REQUIRED,
      position: "",
      sheetName: "",
      isSummaryAttribute: true,
      isFilterable: false,
      isTitleCode: false,
      secondaryReview: false
   }
];

export const EXECUTIVE_STANDARD_COLUMNS = [
   ...RESEARCH_ANALYSIS_STANDARD_COLUMNS,
   {
      tempId: uuidv4(),
      name: "Employee ID",
      systemName: "employee_id",
      dataType: DATA_TYPES.STRING,
      validations: DATA_VALIDATION_TYPES.REQUIRED,
      position: "",
      sheetName: "",
      isSummaryAttribute: true,
      isFilterable: false,
      isTitleCode: false,
      secondaryReview: false
   },
   {
      tempId: uuidv4(),
      name: "Employee Last Name",
      systemName: "employee_last_name",
      dataType: DATA_TYPES.STRING,
      validations: DATA_VALIDATION_TYPES.REQUIRED,
      position: "",
      sheetName: "",
      isSummaryAttribute: true,
      isFilterable: false,
      isTitleCode: false,
      secondaryReview: false
   }
];

export const BROAD_BASED_STANDARD_COLUMNS = [
   ...RESEARCH_ANALYSIS_STANDARD_COLUMNS
];

export const SURVEY_STANDARD_COLUMNS = [
   ...STANDARD_COLUMNS,
   {
      tempId: uuidv4(),
      name: "Survey Year",
      systemName: "survey_year",
      dataType: DATA_TYPES.NUMBER,
      validations: DATA_VALIDATION_TYPES.REQUIRED,
      position: "",
      sheetName: "",
      isSummaryAttribute: true,
      isFilterable: false,
      isTitleCode: false,
      secondaryReview: false
   }
];

export const NORMALIZED_COMPENSATION_PROP_NAME_MAP = new Map([
   ["FYE", "fye"],
   ["Survey Year", "surveyYear"],
   ["Ticker", "lookupKey"],
   ["Company ID", "companyId"],
   ["Employee ID", "employeeId"],
   ["Executive Name", "employeeName"]
]);

export const NORMALIZED_COMPENSATION_DB_ATTR_NAME_MAP = new Map([
   ["FYE", "fye"],
   ["Survey Year", "survey_year"],
   ["Company Name", "company_name"],
   ["Company ID", "company_id"],
   ["Employee ID", "employee_id"],
   ["Ticker", "ticker"],
   ["Executive Name", "employee_name"],
   ["CD&A Disclosure Rank Order", "cda_disclosure_rank"],
   ["AI Generated", "ai_generated"]
]);

export const NORMALIZED_COMPENSATION_GRID_COLUMNS = [
   "FYE",
   "Survey Year",
   "Company Name",
   "Company ID",
   "Employee ID",
   "Ticker",
   "Executive Name",
   "CD&A Disclosure Rank Order",
   "AI Generated"
];

export const REQUIRED_COMPENSATION_FIELDS = [
   "Company ID",
   "FYE",
   "Company Name",
   "Ticker",
   "Employee ID",
];

const parseTickers = (companyIds) => {
   const tickerDelimiter = /\r?\n/;
   const formattedTickers = new Set();
   companyIds.split(tickerDelimiter).forEach(tks => {
      tks.split(',').forEach(ticker => {
         formattedTickers.add(ticker.trim().toUpperCase());
      });
   });
   return formattedTickers;
}

export const formatTickers = (companyIds) => {
   if (companyIds !== null && companyIds.length > 0) {
      if (Array.isArray(companyIds))
         return companyIds.filter(ticker => ticker !== "," || ticker !== "" || ticker !== " ");
      const formattedTickers = parseTickers(companyIds);
      return [...formattedTickers].map(t => t.toString().trim()).filter(t => t !== "" && t !== ",");
   }
};

export const formatCompanyIds = (companyIds) => {
   if (companyIds !== null && companyIds.length > 0) {
      if (Array.isArray(companyIds))
         return companyIds.filter(ticker => ticker !== "," || ticker !== "" || ticker !== " ");
      const formattedCompanyIds = parseCompanyIds(companyIds);
      return [...formattedCompanyIds].map(t => t.toString().trim()).filter(t => t !== "" && t !== ",");
   }
};

const parseCompanyIds = (companyIds) => {
   const delimiter = /\r?\n/; // new line
   const formattedCompanyIDs = new Set();
   companyIds.split(delimiter).forEach(tks => {
      if (tks.split(",").length > 1) {
         tks.split(",").forEach(tk => {
            formattedCompanyIDs.add(tk.trim().toUpperCase());
         });
         return;
      }
      formattedCompanyIDs.add(tks.trim().toUpperCase());
   });
   return formattedCompanyIDs;
};

export const EXPORTED_DATA_REPORT_HEADERS = ['Downloader', 'Template Name', 'Total Companies Downloaded', 'Client Owner Name', 'Client Owner Email', 'Billable Type',
   'Client To Bill', 'Date Downloaded', 'Total Records Downloaded', 'User Notes', 'Admin Notes', "Negotiated Rate", "Is Subscriber"];
// TODO: move these to the database, so that they can be changed without redeploying the app and they can be centralized
export const EXEC_TITLES = [
   { id: "CEO", value: "Principal executive officer" },
   { id: "CFO", value: "Principal financial officer" },
   { id: "EXCH", value: "Executive chair of the board" },
   { id: "VCH", value: "Executive vice chair of the board" },
   { id: "COO", value: "Chief operating officer" },
   { id: "OPS", value: "Top operations" },
   { id: "GC", value: "Top legal" },
   { id: "HR", value: "Top human resources" },
   { id: "MAR", value: "Top marketing" },
   { id: "SALE", value: "Top sales" },
   { id: "PDIV", value: "Division Head" },
   { id: "CADO", value: "Top administrative" },
   { id: "CAO", value: "Top accounting" },
   { id: "CIO", value: "Top information / IT" },
   { id: "CTO", value: "Top technical / technology" },
   { id: "CSO", value: "Top scientific" },
   { id: "RD", value: "Top research & development" },
   { id: "CMO", value: "Top medical" },
   { id: "IR", value: "Top investor relations" },
   { id: "FIN", value: "Second level finance" },
   { id: "BD", value: "Top business development" },
   { id: "CD", value: "Top corporate development" },
   { id: "RISK", value: "Top risk" },
   { id: "LOAN", value: "Top lending" },
   { id: "WM", value: "Top wealth management" },
   { id: "INV", value: "Top investment" },
   { id: "OTHER", value: "Any role not listed above" }
];

export const BILLABLE_TYPES = Object.freeze({ billable: "BILLABLE", customBillable: "CUSTOM", nonBillableRFP: "NON_BILLABLE_RFP", nonBillableOther: "NON_BILLABLE_OTHER", clientDownload: "CLIENT_DOWNLOAD" });

const humanReadableBillableTypeNamesObj = {};

humanReadableBillableTypeNamesObj[BILLABLE_TYPES.billable] = "Billable";
humanReadableBillableTypeNamesObj[BILLABLE_TYPES.nonBillableRFP] = "Non Billable - RFP";
humanReadableBillableTypeNamesObj[BILLABLE_TYPES.nonBillableOther] = "Non Billable - Other";
humanReadableBillableTypeNamesObj[BILLABLE_TYPES.customBillable] = "Custom Billable";
humanReadableBillableTypeNamesObj[BILLABLE_TYPES.clientDownload] = "Client Download";

export const HUMAN_READABLE_BILLABLE_TYPES = Object.freeze(humanReadableBillableTypeNamesObj);

export const MARKET_CAPS = [
   { id: "MEGA_CAP", value: "Mega-Cap: > $200B" },
   { id: "LARGE_CAP", value: "Large-Cap: $10B - $200B" },
   { id: "MID_CAP", value: "Mid-Cap: $2B - $10B" },
   { id: "SMALL_CAP", value: "Small-Cap: $250M - $2B" },
   { id: "MICRO_CAP", value: "Micro-Cap: < $250M" }
];

export const SURVEY_INPUT_PROCESSING_STATES = Object.freeze(
   {
      submitted: "SUBMITTED",
      pendingLeadReview: "PENDING_LEAD_REVIEW",
      readyForReview: "READY_FOR_REVIEW",
      inReview: "IN_REVIEW",
      flaggedForAdminReview: "FLAGGED_FOR_ADMIN_REVIEW",
      flaggedForLeadReview: "FLAGGED_FOR_LEAD_REVIEW",
      awaitingClientResponse: "AWAITING_CLIENT_RESPONSE",
      readyForAdminQC: "READY_FOR_ADMIN_QC",
      reviewComplete: "REVIEW_COMPLETE",
      accepted: "ACCEPTED"
   });

const readableSurveyInputProcessingStatesObj = {};

readableSurveyInputProcessingStatesObj[SURVEY_INPUT_PROCESSING_STATES.submitted] = "Submitted";
readableSurveyInputProcessingStatesObj[SURVEY_INPUT_PROCESSING_STATES.pendingLeadReview] = "Pending Lead Review";
readableSurveyInputProcessingStatesObj[SURVEY_INPUT_PROCESSING_STATES.readyForReview] = "Ready For Review";
readableSurveyInputProcessingStatesObj[SURVEY_INPUT_PROCESSING_STATES.inReview] = "In Review";
readableSurveyInputProcessingStatesObj[SURVEY_INPUT_PROCESSING_STATES.flaggedForAdminReview] = "Flagged For Admin Review";
readableSurveyInputProcessingStatesObj[SURVEY_INPUT_PROCESSING_STATES.flaggedForLeadReview] = "Flagged For Lead Review";
readableSurveyInputProcessingStatesObj[SURVEY_INPUT_PROCESSING_STATES.awaitingClientResponse] = "Awaiting Client Response";
readableSurveyInputProcessingStatesObj[SURVEY_INPUT_PROCESSING_STATES.readyForAdminQC] = "Ready For Admin QC";
readableSurveyInputProcessingStatesObj[SURVEY_INPUT_PROCESSING_STATES.reviewComplete] = "Review Complete";
readableSurveyInputProcessingStatesObj[SURVEY_INPUT_PROCESSING_STATES.accepted] = "Accepted";
export const READABLE_SURVEY_INPUT_PROCESSING_STATES = Object.freeze(readableSurveyInputProcessingStatesObj);


export const FILTER_MNEMONICS = Object.freeze(
   {
      SP500_INDEX: "S&P_500",
      SP400_INDEX: "S&P_400",
      SP1500_INDEX: "S&P_1500",
      SP600_INDEX: "S&P_600",
      RUSSELL3000_INDEX: "RUSSELL_3000",
      NAREIT_INDEX: "NAREIT",
      REVENUE: "revenue",
      MARKET_CAP: "marketCap",
      MARKET_CAP_AVG: "marketCapAvg",
      TOTAL_ASSETS: "totalAssets",
      TOTAL_EMPLOYEES: "totalEmployees"
   }
)

export const STOCK_INDEXES = Object.freeze(
   {
      SP500_INDEX: "S&P_500",
      SP400_INDEX: "S&P_400",
      SP1500_INDEX: "S&P_1500",
      SP600_INDEX: "S&P_600",
      RUSSELL3000_INDEX: "RUSSELL_3000",
      NAREIT_INDEX: "NAREIT"
   }
)

export const GICS_SECTORS = Object.freeze([
   { id: "Health Care", value: "Health Care" },
   { id: "Financials", value: "Financials" },
   { id: "Information Technology", value: "Information Technology" },
   { id: "Real Estate", value: "Real Estate" },
   { id: "Consumer Staples", value: "Consumer Staples" },
   { id: "Materials", value: "Materials" },
   { id: "Industrials", value: "Industrials" },
   { id: "Energy", value: "Energy" },
   { id: "Utilities", value: "Utilities" },
   { id: "Consumer Discretionary", value: "Consumer Discretionary" },
   { id: "Communication Services", value: "Communication Services" }
])

export const GICS_INDUSTRIES = Object.freeze([
   { id: "Oil and Gas Drilling", value: "Oil and Gas Drilling" },
   { id: "Oil and Gas Equipment and Services", value: "Oil and Gas Equipment and Services" },
   { id: "Integrated Oil and Gas", value: "Integrated Oil and Gas" },
   { id: "Oil and Gas Exploration and Production", value: "Oil and Gas Exploration and Production" },
   { id: "Oil and Gas Refining and Marketing", value: "Oil and Gas Refining and Marketing" },
   { id: "Oil and Gas Storage and Transportation", value: "Oil and Gas Storage and Transportation" },
   { id: "Coal and Consumable Fuels", value: "Coal and Consumable Fuels" },
   { id: "Commodity Chemicals", value: "Commodity Chemicals" },
   { id: "Diversified Chemicals", value: "Diversified Chemicals" },
   { id: "Fertilizers and Agricultural Chemicals", value: "Fertilizers and Agricultural Chemicals" },
   { id: "Industrial Gases", value: "Industrial Gases" },
   { id: "Specialty Chemicals", value: "Specialty Chemicals" },
   { id: "Construction Materials", value: "Construction Materials" },
   { id: "Metal, Glass and Plastic Containers", value: "Metal, Glass and Plastic Containers" },
   { id: "Paper and Plastic Packaging Products and Materials", value: "Paper and Plastic Packaging Products and Materials" },
   { id: "Aluminum", value: "Aluminum" },
   { id: "Diversified Metals and Mining", value: "Diversified Metals and Mining" },
   { id: "Copper", value: "Copper" },
   { id: "Gold", value: "Gold" },
   { id: "Precious Metals and Minerals", value: "Precious Metals and Minerals" },
   { id: "Silver", value: "Silver" },
   { id: "Steel", value: "Steel" },
   { id: "Forest Products", value: "Forest Products" },
   { id: "Paper Products", value: "Paper Products" },
   { id: "Aerospace and Defense", value: "Aerospace and Defense" },
   { id: "Building Products", value: "Building Products" },
   { id: "Construction and Engineering", value: "Construction and Engineering" },
   { id: "Electrical Components and Equipment", value: "Electrical Components and Equipment" },
   { id: "Heavy Electrical Equipment", value: "Heavy Electrical Equipment" },
   { id: "Industrial Conglomerates", value: "Industrial Conglomerates" },
   { id: "Construction Machinery and Heavy Transportation Equipment", value: "Construction Machinery and Heavy Transportation Equipment" },
   { id: "Agricultural and Farm Machinery", value: "Agricultural and Farm Machinery" },
   { id: "Industrial Machinery and Supplies and Components", value: "Industrial Machinery and Supplies and Components" },
   { id: "Trading Companies and Distributors", value: "Trading Companies and Distributors" },
   { id: "Commercial Printing", value: "Commercial Printing" },
   { id: "Environmental and Facilities Services", value: "Environmental and Facilities Services" },
   { id: "Office Services and Supplies", value: "Office Services and Supplies" },
   { id: "Diversified Support Services", value: "Diversified Support Services" },
   { id: "Security and Alarm Services", value: "Security and Alarm Services" },
   { id: "Human Resource and Employment Services", value: "Human Resource and Employment Services" },
   { id: "Research and Consulting Services", value: "Research and Consulting Services" },
   { id: "Air Freight and Logistics", value: "Air Freight and Logistics" },
   { id: "Passenger Airlines", value: "Passenger Airlines" },
   { id: "Marine Transportation", value: "Marine Transportation" },
   { id: "Rail Transportation", value: "Rail Transportation" },
   { id: "Trucking", value: "Trucking" },
   { id: "Cargo Ground Transportation", value: "Cargo Ground Transportation" },
   { id: "Passenger Ground Transportation", value: "Passenger Ground Transportation" },
   { id: "Airport Services", value: "Airport Services" },
   { id: "Highways and Railtracks", value: "Highways and Railtracks" },
   { id: "Marine Ports and Services", value: "Marine Ports and Services" },
   { id: "Automotive Parts and Equipment", value: "Automotive Parts and Equipment" },
   { id: "Tires and Rubber", value: "Tires and Rubber" },
   { id: "Automobile Manufacturers", value: "Automobile Manufacturers" },
   { id: "Motorcycle Manufacturers", value: "Motorcycle Manufacturers" },
   { id: "Consumer Electronics", value: "Consumer Electronics" },
   { id: "Home Furnishings", value: "Home Furnishings" },
   { id: "Homebuilding", value: "Homebuilding" },
   { id: "Household Appliances", value: "Household Appliances" },
   { id: "Housewares and Specialties", value: "Housewares and Specialties" },
   { id: "Leisure Products", value: "Leisure Products" },
   { id: "Apparel, Accessories and Luxury Goods", value: "Apparel, Accessories and Luxury Goods" },
   { id: "Footwear", value: "Footwear" },
   { id: "Textiles", value: "Textiles" },
   { id: "Casinos and Gaming", value: "Casinos and Gaming" },
   { id: "Hotels, Resorts and Cruise Lines", value: "Hotels, Resorts and Cruise Lines" },
   { id: "Leisure Facilities", value: "Leisure Facilities" },
   { id: "Restaurants", value: "Restaurants" },
   { id: "Education Services", value: "Education Services" },
   { id: "Specialized Consumer Services", value: "Specialized Consumer Services" },
   { id: "Distributors", value: "Distributors" },
   { id: "Internet and Direct Marketing Retail", value: "Internet and Direct Marketing Retail" },
   { id: "Department Stores", value: "Department Stores" },
   { id: "General Merchandise Stores", value: "General Merchandise Stores" },
   { id: "Broadline Retail", value: "Broadline Retail" },
   { id: "Apparel Retail", value: "Apparel Retail" },
   { id: "Computer and Electronics Retail", value: "Computer and Electronics Retail" },
   { id: "Home Improvement Retail", value: "Home Improvement Retail" },
   { id: "Other Specialty Retail", value: "Other Specialty Retail" },
   { id: "Automotive Retail", value: "Automotive Retail" },
   { id: "Homefurnishing Retail", value: "Homefurnishing Retail" },
   { id: "Drug Retail", value: "Drug Retail" },
   { id: "Food Distributors", value: "Food Distributors" },
   { id: "Food Retail", value: "Food Retail" },
   { id: "Consumer Staples Merchandise Retail", value: "Consumer Staples Merchandise Retail" },
   { id: "Brewers", value: "Brewers" },
   { id: "Distillers and Vintners", value: "Distillers and Vintners" },
   { id: "Soft Drinks and Non-alcoholic Beverages", value: "Soft Drinks and Non-alcoholic Beverages" },
   { id: "Agricultural Products and Services", value: "Agricultural Products and Services" },
   { id: "Packaged Foods and Meats", value: "Packaged Foods and Meats" },
   { id: "Tobacco", value: "Tobacco" },
   { id: "Household Products", value: "Household Products" },
   { id: "Personal Care Products", value: "Personal Care Products" },
   { id: "Health Care Equipment", value: "Health Care Equipment" },
   { id: "Health Care Supplies", value: "Health Care Supplies" },
   { id: "Health Care Distributors", value: "Health Care Distributors" },
   { id: "Health Care Services", value: "Health Care Services" },
   { id: "Health Care Facilities", value: "Health Care Facilities" },
   { id: "Managed Health Care", value: "Managed Health Care" },
   { id: "Health Care Technology", value: "Health Care Technology" },
   { id: "Biotechnology", value: "Biotechnology" },
   { id: "Pharmaceuticals", value: "Pharmaceuticals" },
   { id: "Life Sciences Tools and Services", value: "Life Sciences Tools and Services" },
   { id: "Diversified Banks", value: "Diversified Banks" },
   { id: "Regional Banks", value: "Regional Banks" },
   { id: "Thrifts and Mortgage Finance", value: "Thrifts and Mortgage Finance" },
   { id: "Diversified Financial Services", value: "Diversified Financial Services" },
   { id: "Multi-Sector Holdings", value: "Multi-Sector Holdings" },
   { id: "Specialized Finance", value: "Specialized Finance" },
   { id: "Commercial and Residential Mortgage Finance", value: "Commercial and Residential Mortgage Finance" },
   { id: "Transaction and Payment Processing Services", value: "Transaction and Payment Processing Services" },
   { id: "Consumer Finance", value: "Consumer Finance" },
   { id: "Asset Management and Custody Banks", value: "Asset Management and Custody Banks" },
   { id: "Investment Banking and Brokerage", value: "Investment Banking and Brokerage" },
   { id: "Diversified Capital Markets", value: "Diversified Capital Markets" },
   { id: "Financial Exchanges and Data", value: "Financial Exchanges and Data" },
   { id: "Mortgage REITs", value: "Mortgage REITs" },
   { id: "Insurance Brokers", value: "Insurance Brokers" },
   { id: "Life and Health Insurance", value: "Life and Health Insurance" },
   { id: "Multi-line Insurance", value: "Multi-line Insurance" },
   { id: "Property and Casualty Insurance", value: "Property and Casualty Insurance" },
   { id: "Reinsurance", value: "Reinsurance" },
   { id: "IT Consulting and Other Services", value: "IT Consulting and Other Services" },
   { id: "Data Processing and Outsourced Services", value: "Data Processing and Outsourced Services" },
   { id: "Internet Services and Infrastructure", value: "Internet Services and Infrastructure" },
   { id: "Application Software", value: "Application Software" },
   { id: "Systems Software", value: "Systems Software" },
   { id: "Communications Equipment", value: "Communications Equipment" },
   { id: "Technology Hardware, Storage and Peripherals", value: "Technology Hardware, Storage and Peripherals" },
   { id: "Electronic Equipment and Instruments", value: "Electronic Equipment and Instruments" },
   { id: "Electronic Components", value: "Electronic Components" },
   { id: "Electronic Manufacturing Services", value: "Electronic Manufacturing Services" },
   { id: "Technology Distributors", value: "Technology Distributors" },
   { id: "Semiconductor Materials and Equipment", value: "Semiconductor Materials and Equipment" },
   { id: "Semiconductors", value: "Semiconductors" },
   { id: "Alternative Carriers", value: "Alternative Carriers" },
   { id: "Integrated Telecommunication Services", value: "Integrated Telecommunication Services" },
   { id: "Wireless Telecommunication Services", value: "Wireless Telecommunication Services" },
   { id: "Advertising", value: "Advertising" },
   { id: "Broadcasting", value: "Broadcasting" },
   { id: "Cable and Satellite", value: "Cable and Satellite" },
   { id: "Publishing", value: "Publishing" },
   { id: "Movies and Entertainment", value: "Movies and Entertainment" },
   { id: "Interactive Home Entertainment", value: "Interactive Home Entertainment" },
   { id: "Interactive Media and Services", value: "Interactive Media and Services" },
   { id: "Electric Utilities", value: "Electric Utilities" },
   { id: "Gas Utilities", value: "Gas Utilities" },
   { id: "Multi-Utilities", value: "Multi-Utilities" },
   { id: "Water Utilities", value: "Water Utilities" },
   { id: "Independent Power Producers and Energy Traders", value: "Independent Power Producers and Energy Traders" },
   { id: "Renewable Electricity", value: "Renewable Electricity" },
   { id: "Diversified REITs", value: "Diversified REITs" },
   { id: "Industrial REITs", value: "Industrial REITs" },
   { id: "Hotel and Resort REITs", value: "Hotel and Resort REITs" },
   { id: "Office REITs", value: "Office REITs" },
   { id: "Health Care REITs", value: "Health Care REITs" },
   { id: "Residential REITs", value: "Residential REITs" },
   { id: "Multi-Family Residential REITs", value: "Multi-Family Residential REITs" },
   { id: "Single-Family Residential REITs", value: "Single-Family Residential REITs" },
   { id: "Retail REITs", value: "Retail REITs" },
   { id: "Other Specialized REITs", value: "Other Specialized REITs" },
   { id: "Self-Storage REITs", value: "Self-Storage REITs" },
   { id: "Telecom Tower REITs", value: "Telecom Tower REITs" },
   { id: "Timber REITs", value: "Timber REITs" },
   { id: "Data Center REITs", value: "Data Center REITs" },
   { id: "Diversified Real Estate Activities", value: "Diversified Real Estate Activities" },
   { id: "Real Estate Operating Companies", value: "Real Estate Operating Companies" },
   { id: "Real Estate Development", value: "Real Estate Development" },
   { id: "Real Estate Services", value: "Real Estate Services" }
])

export const BENCHMARK_CODE_MAP = Object.freeze({
    "BRAND": "Brand Leader",
    "BUO<1B": "Business Unit Officer - <$1B Unit Revenue",
    "BUO>10B": "Business Unit Officer - >$10B Unit Revenue",
    "BUO1-2.5B": "Business Unit Officer - $1.0–$2.5B Unit Revenue",
    "BUO2.5-5B": "Business Unit Officer - $2.5–$5B Unit Revenue",
    "BUO5-10B": "Business Unit Officer - $5–$10B Unit Revenue",
    "BUO": "Business Unit Officer - All",
    "CAO": "Chief Accounting Officer",
    "F-ACTU": "Chief Actuary",
    "CADO": "Chief Administrative Officer",
    "AUDIT": "Chief Auditor",
    "F-BANK": "Chief Banking Officer",
    "F-CLMS": "Chief Claims Officer",
    "COMMS": "Chief Communications Officer",
    "CA": "Chief Corporate Affairs Officer",
    "F-CRED": "Chief Credit Officer",
    "CCO": "Chief Customer Officer",
    "CDO": "Chief Digital Officer",
    "CEO": "Chief Executive Officer",
    "CFO": "Chief Financial Officer",
    "EU-GEOL": "Chief Geologist",
    "CIO": "Chief Information Officer",
    "CISO": "Chief Information Security Officer",
    "F-INV": "Chief Investment Officer",
    "GC": "Chief Legal Officer",
    "F-LEND": "Chief Lending Officer",
    "H-MED": "Chief Medical Officer",
    "EU-NUC": "Chief Nuclear Officer",
    "STAFF": "Chief of Staff",
    "COO": "Chief Operating Officer",
    "CPIO": "Chief Product Innovation Officer",
    "REG": "Chief Regulatory/Compliance Officer",
    "F-RISK": "Chief Risk Officer",
    "T-CTO": "Chief Technology Officer",
    "F-UWRT": "Chief Underwriting",
    "CONTR": "Controller",
    "SECY": "Corporate Secretary",
    "DGC": "Deputy General Counsel",
    "DIV<1B": "Division Head - <$1B Unit Revenue",
    "DIV>10B": "Division Head - >$10B Unit Revenue",
    "DIV1-2.5B": "Division Head - $1.0–$2.5B Unit Revenue",
    "DIV2.5-5B": "Division Head - $2.5–$5B Unit Revenue",
    "DIV5-10B": "Division Head - $5–$10B Unit Revenue",
    "DIV": "Division Head - All",
    "H-CDEV": "Head of Clinical Development",
    "F-COMBK": "Head of Commercial Banking",
    "F-CONBK": "Head of Consumer Banking",
    "EU-EXPL": "Head of Exploration",
    "F-WMGMT": "Head of Wealth Management",
    "EU-ADEV": "Top Asset Development",
    "BD": "Top Business Development",
    "CMRL": "Top Commercial/Revenue",
    "COMP": "Top Compensation / Total Rewards Executive",
    "R-CREAT": "Top Creative",
    "DATA": "Top Data Analytics",
    "EU-DCMP": "Top Drilling & Completions",
    "EU-GRID": "Top Electric Transmission / Grid",
    "SEC": "Top Employee/Property Security",
    "EU-ENG": "Top Energy Engineering / Technical",
    "EU-EMTRD": "Top Energy Marketing / Trading",
    "EH": "Top Environmental and Safety Executive",
    "EU-PROD": "Top Field Production",
    "FPA": "Top Financial Planning Executive",
    "EU-GAPR": "Top Gathering and Processing",
    "GA": "Top Government Affairs/Relations Officer",
    "HR": "Top Human Resources",
    "IR": "Top Investor Relations",
    "LABR": "Top Labor Relations",
    "EU-LAND": "Top Land",
    "LOG": "Top Logistics",
    "MFG": "Top Manufacturing/Engineering",
    "MAR": "Top Marketing",
    "OPS": "Top Operations Executive",
    "PC": "Top Patent Counsel",
    "PROC": "Top Procurement Executive",
    "REPD": "Top Real Estate/Property Development",
    "EU-REFN": "Top Refining",
    "H-RD": "Top Research & Development Executive",
    "R-MERCH": "Top Retail Merchandising",
    "R-STORE": "Top Retail Store Management",
    "SALE": "Top Sales Executive",
    "T-ENG": "Top Software Engineering Executive",
    "T-PROD": "Top Software/Tech Product Officer",
    "STRAT": "Top Strategy & Development",
    "SC": "Top Supply Chain",
    "TMD": "Top Talent Management/Development",
    "TAX": "Top Tax",
    "TREAS": "Treasurer"
});

export const SURVEY_INDUSTRY_GROUPINGS = Object.freeze({
   ALL: "All Sectors/Industries",
   REGIONAL_BANKS: "Regional Banks",
   CONSUMER_PACKAGED_GOODS: "Consumer Packaged Goods",
   TECHNOLOGY: "Technology",
   UTILITIES: "Utilities",
   RESTAURANTS_HOSPITALITY: "Restaurants & Hospitality",
   EQUITY_REITS: "Equity REITs",
   APPAREL_PERSONAL_CARE: "Apparel & Personal Care",
   TRANSPORTATION: "Transportation"
})

export const REPORTING_LEVEL_GROUPINGS = Object.freeze({
   ALL: "All Reporting Levels",
   LEVEL_2: "Reporting Level 2 (CEO Direct Reports)",
   LEVEL_3: "Reporting Level 3",
   LEVEL_4: "Reporting Level 4 And Below"
})

export const SURVEY_BREAKOUTS = Object.freeze({
   ALL: "All Sizes",
   MEGA_CAP: "S&P 100 (Mega-Cap)",
   LARGE_CAP: "S&P 500 (Large-Cap)",
   MID_CAP: "S&P 400 (Mid-Cap)",
   REVENUE_ABOVE_40B: "Revenue >= $40B",
   REVENUE_20B_TO_40B: "$20B <= Revenue < $40B",
   REVENUE_10B_TO_20B: "$10B <= Revenue < $20B",
   REVENUE_5B_TO_10B: "$5B <= Revenue < $10B",
   REVENUE_2B_TO_5B: "$2.5B <= Revenue < $5B",
   REVENUE_1B_TO_2B: "$1B <= Revenue < $2.5B",
   REVENUE_BELOW_1B: "Revenue < $1B",
   REVENUE_UNDER_5_B: "Revenue < $5B",
   REVENUE_ABOVE_5_B: "Revenue > $5B",
   MARKET_CAP_ABOVE_50B: "Market Cap >= $50B",
   MARKET_CAP_25B_TO_50B: "$25B <= Market Cap < $50B",
   MARKET_CAP_10B_TO_25B: "$10B <= Market Cap < $25B",
   MARKET_CAP_5B_TO_10B: "$5B <= Market Cap < $10B",
   MARKET_CAP_2B_TO_5B: "$2.5B <= Market Cap < $5B",
   MARKT_CAP_BELOW_2B: "Market Cap < $2.5B"
});

export const SURVEY_STATISTICS = Object.freeze({
   SEVENTY_FIVE_PERCENTILE: "75th Percentile",
   TWENTY_FIVE_PERCENTILE: "25th Percentile",
   MEDIAN: "Median",
   MEAN: "Mean"
});
